import gql from 'graphql-tag'

export const GET_STORIES_DATA = gql`
  query storiesStats($waveId: String, $labId: String, $accountIds: [String]) {
    coordinator(accountIds: $accountIds) {
      wave {
        list(filter: { labId: $labId }) {
          id
          name
        }
      }
      stats(waveId: $waveId, labId: $labId) {
        stories {
          total
          perLearner
          perDay
          byType {
            resourceType
            count
          }
        }
        tags {
          top(count: 100) {
            id
            name
            usageCount
          }
        }
      }
    }
  }
`
export const GET_STORIES_LIST = gql`
  query storiesList(
    $waveId: String
    $storyType: StoryResourceTypeEnum
    $saved: Boolean
    $tagIds: [String!]
    $labId: String
    $accountIds: [String]
  ) {
    coordinator(accountIds: $accountIds) {
      wave {
        list(filter: { labId: $labId }) {
          id
          name
        }
      }
      story {
        list(filter: { labId: $labId, waveId: $waveId, storyType: $storyType, saved: $saved, tagIds: $tagIds }) {
          id
          name
          resourceType
          thumbnailLocation
          resourceUri
          dateCreated
          tags {
            name
            id
          }
          user {
            id
            userName
            firstName
            lastName
            waves {
              id
              name
            }
          }
        }
      }
      storyTag {
        list(filter: { labId: $labId, waveId: $waveId, storyType: $storyType, saved: $saved }) {
          id
          name
          usageCount
        }
      }
    }
  }
`

export const SIGN_FILE_LINK = gql`
  query signFileLink($linkToSign: String!) {
    me {
      security {
        signFileLink(linkToSign: $linkToSign) {
          preSignedLink
          expiresAt
        }
      }
    }
  }
`

export const SIGN_FILE_LINKS = gql`
  query signLinks($linksToSign: [String!]!) {
    me {
      security {
        signFileLinks(linksToSign: $linksToSign) {
          preSignedLink
          expiresAt
        }
      }
    }
  }
`
